import { useAuthStore } from '@/store/auth';
import { getQueryClient } from './queryClient';
import { invalidateSessionSensitiveRequests } from '@/lib/sessionSensitiveRequestManager';

let hasHandledExpiration = false;

export function handleSessionExpired(): void {
    if (hasHandledExpiration || useAuthStore.getState().isLoggingOut) {
        return;
    }

    hasHandledExpiration = true;

    const { logout, setIsLoggingOut } = useAuthStore.getState();
    setIsLoggingOut(true);

    const queryClient = getQueryClient();
    queryClient.clear();

    logout();
    invalidateSessionSensitiveRequests();

    if (window.location.pathname !== '/login') {
        window.location.replace('/login');
    }
}

export type AppNavigate = (path: string) => void;

let appNavigate: AppNavigate | null = null;

/** Lets session handling route within the app instead of reloading the document. */
export function registerAppNavigate(navigate: AppNavigate | null): void {
    appNavigate = navigate;
}

/**
 * Newly applicable legal terms deny every operational request. Send the user to
 * the legal workflow once instead of leaving each screen to show its own error.
 * In-app navigation lets the page's other requests finish; a document load
 * would abort them.
 */
export function handleLegalAcceptanceRequired(): void {
    const { pathname, search } = window.location;
    if (pathname.startsWith('/legal-workflow') || pathname.startsWith('/login')) {
        return;
    }
    const legalWorkflowPath = `/legal-workflow?returnTo=${encodeURIComponent(pathname + search)}`;
    if (appNavigate === null) {
        window.location.assign(legalWorkflowPath);
        return;
    }
    appNavigate(legalWorkflowPath);
}
